import React from 'react';
import Logo from '../Logo';
import './style.scss';

class Header extends React.Component {
  render() {
    return (
      <nav style={navStyle}>
        <div style={logoContainerStyle} >
            <Logo />
        </div>
      </nav >
    );
  }
}

const navStyle = {
  top: 10,
  verticalAlign: 'top',
  paddingTop: '2.78%',
  width: '100%',
  zIndex: 1,
  textAlign: 'center',
  fontSize: '22px',
  // display: 'block',
  WebkitFontSmoothing: 'antialiased',
  textRendering: 'optimizeSpeed',
  cursor: 'pointer',
}

const logoContainerStyle = {
  verticalAlign: 'middle',
  textAlign: 'center',
  whiteSpace: 'nowrap',
  fontSize: '22px',
  height: '50px',
  textAlign: 'center !important',
  border: 0,
  margin: 'auto',
  padding: 0,
  cursor: 'pointer'
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/index.jsx